import * as uuid from "uuid";

import {SQFTResourceController} from "./SQFTResourceController";
import {WORKSPACE_RESOURCES} from "../../../../constants";
import workspace from "../../core/workspace";
import {LineHandlesModel} from "../models/LineHandlesModel";
import store from "../../../../../../store";
import {getQtCatName} from "../../../../helpers/sqftQuotesHelper";
import {getQuantityFromFiltersByShapes} from "../../../../helpers/sqftCalculations";
import workspaceControllers, {QUANTITY_GROUP} from "../workspaceControllers";
import {SHAPE_LAYOUTS} from "../../core/cabinet/cabinetShapes";
import {setResourceControllerCounter} from "../../../../../../actions/sqftResourceFunctions";
import {getWizardPropertiesForFeature} from "../../core/controls/resourseCanas";
import {isShapeTallCabinet} from "../../../../helpers/cabinetBoxCompatibilityHelper";
import {
  getTallCabinetHandleQuantities,
  hasTallCabinetInteriorLayout,
} from "../../../../helpers/tallCabinetInteriorHelper";

export class HandlesController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.handles;
  }

  /** overrides **/
  removeResourceById(id) {
    //remove line attachment
    const resource = this.getResourceById(id);
    if (resource) {
      const line = workspace.getLineById(resource.lineId);
      line.setHandleId(null);
      line.setHandleV3dURL(null);
      line.setHandleH3dURL(null);
    }
    const result = super.removeResourceById(id);

    return result;
  }
  /** overrides **/

  addOrChangeHandlesToTheShape(shape, feature) {
    // const existingHandles = this.getAllResourcesForTheShape(shape.id);
    // if (Array.isArray(existingHandles) && existingHandles.length) {
    //   this.shapeCabinet.deleteAttachedFeatures();
    //   this.shapeCabinet.generateAttachedFeatures();
    // }
    const handles = this.getAllResourcesForTheShape(shape.id);
    if (handles.length) {
      this.changeHandlesForSelectedShapes([shape], feature);
    } else {
      this.addHandleToTheShape(shape, feature);
    }
  }

  addHandleToTheShape(shape, feature) {
    this.updateShapeLineHandleFeature([shape], feature);
    this.createModelsForTheShape(shape, feature);
    this.updateReduxCounterOnChange();
  }

  changeHandlesForSelectedShapes(shapes, feature, quantityGroup) {
    // const reduxState = store.getState();
    // const selectedFeature = reduxState.sqftResourceState.selectedHandle

    this.updateResourcesFeature(shapes, feature, quantityGroup);
    this.updateShapeLineHandleFeature(shapes, feature);
    this.updateReduxCounterOnChange();
  }

  hydrateHandleResource(resource) {
    if (resource instanceof LineHandlesModel || typeof resource?.changeFeature === 'function') {
      return resource;
    }

    return new LineHandlesModel(
      resource.shapeId,
      resource.lineId,
      resource.featureId,
      resource.sharedFeatureName,
      resource.id,
      resource.qtCatName,
      resource.partId,
      resource.quantity,
      resource.quantityInGroup,
      resource.quantityGroup,
      resource.handleV3dURL,
      resource.handleH3dURL,
      resource.isDisabledInPopup,
      resource.fromWizardId,
      resource.fromWizardStep,
      resource.fromWizardGroupId,
    );
  }

  importData(data) {
    const resources = Array.isArray(data) ? data : [];
    workspace[this.resourceName] = resources.map((resource) => this.hydrateHandleResource(resource));
  }

  updateResourcesFeature(shapes, feature, quantityGroup = '') {
    const selectedShapesIds = shapes.map(shape => shape.id);
    const resources = this.getResources().map((resource, index) => {
      const hydratedResource = this.hydrateHandleResource(resource);
      if (hydratedResource !== resource) {
        workspace[this.resourceName][index] = hydratedResource;
      }

      return hydratedResource;
    });
    const wizardProps = this.getWizardProps(feature);
    for (const resource of resources) {
      if (selectedShapesIds.includes(resource.shapeId)
        && (quantityGroup === '' || quantityGroup === resource.quantityGroup)
      ) {
        resource.changeFeature(feature, wizardProps);
      }
    }
    this.updateReduxCounterOnChange();
  }

  getWizardProps(feature) {
    return getWizardPropertiesForFeature(feature, true);
  }

  updateShapeLineHandleFeature(shapes, feature) {
    for (const shape of shapes) {
      const lines = shape.getLines();
      let linesToAddHandle;
      switch (shape.shapeParams.shapeLayout) {
        case SHAPE_LAYOUTS.LowerIroningBoardRight:
        case SHAPE_LAYOUTS.LowerIroningBoardLeft:
          linesToAddHandle = [];
          break
        case SHAPE_LAYOUTS.LowerDimondCorner:
        case SHAPE_LAYOUTS.UpperDimondCorner:
          linesToAddHandle = [lines[4]];
          break
        default:
          linesToAddHandle = [lines[2]];
          break
      }
      for (const line of linesToAddHandle) {
        line.setHandleId(feature.dbFeature.id);
        const handleV3dURL = this.findGLBModel(feature.dbFeature.thirdPartyAR3DUrls, 'V');
        const handleH3dURL = this.findGLBModel(feature.dbFeature.thirdPartyAR3DUrls, 'H');

        line.setHandleV3dURL(handleV3dURL);
        line.setHandleH3dURL(handleH3dURL);
      }
    }
    this.updateReduxCounterOnChange();
  }

  createModelsForTheShape = (shape, feature) => {
    const lines = shape.getLines();
    let quantity = +getQuantityFromFiltersByShapes([shape], 'Number_of_Knobs');
    let doors = +getQuantityFromFiltersByShapes([shape], 'Number_of_Doors');
    let drawers = +getQuantityFromFiltersByShapes([shape], 'Number_of_Drawers');

    if (isShapeTallCabinet(shape) && hasTallCabinetInteriorLayout(shape)) {
      const tallCabinetHandles = getTallCabinetHandleQuantities(shape);
      quantity = tallCabinetHandles.total;
      doors = tallCabinetHandles.doors;
      drawers = tallCabinetHandles.drawers;
    }

    const handleV3dURL = this.findGLBModel(feature.dbFeature.thirdPartyAR3DUrls, 'V');
    const handleH3dURL = this.findGLBModel(feature.dbFeature.thirdPartyAR3DUrls, 'H');
    const {fromWizardId, fromWizardStep, fromWizardGroupId} = this.getWizardProps(feature);

    //assign all knobs to the doors
    if (doors && quantity) {
      this.addResource(new LineHandlesModel(
        shape.id,
        lines[2].id,
        feature.dbFeature.id,
        feature.dbFeature.sharedFeatureName,
        uuid.v4(),
        getQtCatName(),
        feature.partId,
        quantity === drawers ? quantity : quantity - drawers,
        doors,
        QUANTITY_GROUP.doors,
        handleV3dURL,
        handleH3dURL,
        false,
        fromWizardId,
        fromWizardStep,
        fromWizardGroupId,
        )
      );
    }

    //if knobs are left then assign them to drawers
    if (drawers && quantity && quantity - doors) {
      workspaceControllers.handles.addResource(new LineHandlesModel(
        shape.id,
        lines[2].id,
        feature.dbFeature.id,
        feature.dbFeature.sharedFeatureName,
        uuid.v4(),
        getQtCatName(),
        feature.partId,
        quantity === doors ? quantity : quantity - doors,
        drawers,
        QUANTITY_GROUP.drawers,
        handleV3dURL,
        handleH3dURL,
        false,
        fromWizardId,
        fromWizardStep,
        fromWizardGroupId,
        )
      );
    }
  }

  /**
   * Function to find a .glb model in the array based on H or V suffix.
   * If the parameter is not passed or no matching model is found, it returns the first .glb model found.
   *
   * @param {Array} urls - Array of URLs.
   * @param {String} [suffix] - Optional. Suffix 'H' or 'V' to search for in the URL.
   * @returns {String} - The found .glb model URL or the first .glb model in the array.
   */
  findGLBModel(urls, suffix) {
    if (!urls) {
      return null
    }

    const glbModels = urls.filter(url => url.endsWith('.glb'));

    if (!glbModels.length) {
      return null;
    }

    // If suffix is provided (either 'H' or 'V'), search for a model with that suffix
    if (suffix) {
      const modelWithSuffix = glbModels.find(url => url.endsWith(`-${suffix}.glb`));
      if (modelWithSuffix) {
        return modelWithSuffix;
      }
    }

    return glbModels[0];
  }

  exportHandles() {
    return this.exportData()
  }

  // updateResourcesId(featureId, partId, quantityGroup = '') {
  //   const resources = this.getResources();
  //   for (const resource of resources) {
  //     if (resource.partId === partId && (quantityGroup === '' || quantityGroup === resource.quantityGroup)) {
  //       resource.featureId = featureId
  //     }
  //   }
  // }

  updateFeatureById(oldFeatureId, newFeature) {
    const affectedShapeIds = new Set(
      this.getResources()
        .filter(r => r.featureId === oldFeatureId)
        .map(r => r.shapeId)
    );

    super.updateFeatureById(oldFeatureId, newFeature);

    if (affectedShapeIds.size) {
      const shapes = [...affectedShapeIds]
        .map(id => workspace.getShapeById(id))
        .filter(Boolean);
      this.updateShapeLineHandleFeature(shapes, newFeature);
    }
  }

  getAllResourcesForTheShape(shapeId) {
    return workspace[this.resourceName].filter((resource) => resource.shapeId === shapeId);
  }

  deleteAllResourcesForTheShape(shapeId) {
    workspace[this.resourceName] = workspace[this.resourceName].filter(
      (resource) => resource.shapeId !== shapeId
    );
    this.updateReduxCounterOnChange();
  }

  updateReduxCounterOnChange = () => {
    const reduxState = store.getState();
    const counter = reduxState.sqftResourceState.resourceControllerCounter
    store.dispatch(setResourceControllerCounter(counter + 1));
  }
}

